import { LogoutIcon } from 'tdesign-icons-vue-next';
import { shallowRef } from 'vue';
import { RouteRecordRaw } from 'vue-router';

import Layout from '@/layouts/index.vue';

export default [
  {
    path: '/user',
    name: 'user',
    component: Layout,
    redirect: '/user/index',
    meta: {
      title: '个人中心',
      icon: 'user-circle',
    },
    children: [
      {
        path: 'index',
        name: 'UserIndex',
        component: () => import('@/pages/user/index.vue'),
        meta: {
          title: '个人中心',
        },
      },
    ],
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      title: '登录页',
      icon: shallowRef(LogoutIcon),
    },
    component: () => import('@/layouts/blank-layout.vue'),
    children: [
      {
        path: 'index',
        component: () => import('@/layouts/blank-layout.vue'),
        meta: {
          title: '登录页',
        },
      },
    ],
  },
] as RouteRecordRaw[];
